'use client';

import React from 'react';
import { AntdRegistry as Registry } from '@ant-design/nextjs-registry';
import { ConfigProvider, theme } from 'antd';
import idID from 'antd/locale/id_ID';
import dayjs from 'dayjs';
import 'dayjs/locale/id';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { PASTEL_THEME } from './PastelBadge';

dayjs.extend(customParseFormat);
dayjs.locale('id');

export default function AntdRegistry({ children }: { children: React.ReactNode }) {
  return (
    <Registry>
      <ConfigProvider
        locale={idID}
        theme={{
          algorithm: theme.defaultAlgorithm,
          token: {
            colorPrimary: PASTEL_THEME.primary,
            colorPrimaryHover: PASTEL_THEME.primaryHover,
            colorPrimaryActive: PASTEL_THEME.primaryActive,
            colorBgBase: '#FFFFFF',
            colorBgLayout: '#F8FAFC',
            borderRadius: 12,
            borderRadiusLG: 14,
            borderRadiusSM: 8,
            fontFamily:
              'var(--font-geist-sans), -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
          },
          components: {
            Card: {
              borderRadiusLG: 14,
              colorBorderSecondary: '#F1F5F9',
            },
            Button: {
              borderRadius: 10,
              controlHeight: 38,
              fontWeight: 500,
            },
            Table: {
              borderRadius: 12,
              headerBg: '#F8FAFC',
              headerColor: '#475569',
              rowHoverBg: '#F1F5F9',
            },
            Input: {
              borderRadius: 8,
              controlHeight: 38,
            },
            Select: {
              borderRadius: 8,
              controlHeight: 38,
            },
            Tag: {
              borderRadiusSM: 6,
            },
          },
        }}
      >
        {children}
      </ConfigProvider>
    </Registry>
  );
}
